<db-dialog-wrapper [dialog]="this" [width]="'488px'">
  <div class="db-confirm-dialog">
    <div class="db-confirm-dialog__header">{{header}}</div>
    <div class="db-confirm-dialog__message">
      <p [innerHTML]="message"></p>
    </div>
    <div class="db-confirm-dialog__buttons">
      <a *ngIf="!product || (product && !product.networkActive)" class="db-button" (click)="confirm('single', singleSiteButtonText)" ><span>{{singleSiteButtonText}}</span></a>
      <a class="db-button db-button_info" (click)="confirm('network', multisiteButtonText)"><span>{{multisiteButtonText}}</span></a>
    </div>
  </div>
</db-dialog-wrapper>
